/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontSocial_user$ref = any;
export type StorefrontSocial_user = {
    readonly serviceId: string | null;
    readonly " $refType": StorefrontSocial_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontSocial_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '88b81f8bc399bdcf21454342b168132d';
export default node;
